
<template>
  <div>
    <div v-bind:class="{'hidden': hideListing, 'list-container': true, 'kanban-main': true}">
      <v-layout row wrap>
        <v-flex xl2 lg2 md2 sm12 xs12 v-for="board in boards" v-bind:key="board.statusId">
          <div class="drag-column">
            <span
              class="drag-column-header"
              v-bind:style="{ borderBottom: '2px solid ' + board.color }"
            >
              <div>
                <h3>{{board.name}}</h3>
              </div>
            </span>

            <draggable
              :list="board.cards"
              group="cards"
              @start="drag=false"
              @end="drag=true"
              :style="{ 'height': dragAreaHeightSize }"
              @change="itemMovedHandler"
            >
              <div
                v-for="card in board.cards"
                :key="card.cardId"
                v-on:dblclick="openCard($event, card.cardId)"
                class="drag-item"
              >
                <div>
                  <div class="rb-header-2" :style="{ 'background-color': card.cardTypeColor }"></div>
                  <div>#{{card.cardId}}</div>
                  <div class="card-name">{{card.name}}</div>
                  <div class="avatar2">
                    <span v-for="member in card.assignedMembers" :key="member.id">
                      <img
                        v-bind:src="member.image"
                        :alt="member.name"
                        style="width:28px; border-radius: 50%;"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </v-flex>
      </v-layout>
      <div class="fab-icon">
        <v-speed-dial
          v-model="fab"
          :bottom="true"
          :right="true"
          direction="top"
          :open-on-hover="true"
          transition="slide-y-reverse-transition"
        >
          <v-btn v-model="fab" color="secondary" dark fab slot="activator">
            <v-icon v-if="fab">close</v-icon>
            <v-icon v-else>add</v-icon>
          </v-btn>
          <v-btn fab dark small color="green" :to="editLink()">
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn fab dark small color="indigo" :to="addLink()">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn fab dark small color="red">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-speed-dial>
      </div>
    </div>
    <router-view v-on:back="goBackAction" v-on:save="load"></router-view>
  </div>
</template>

<script>
import GenericRepository from "../../services/GenericRepository.js";
import HAL from "../../helpers/HAL.js";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
export default {
  name: "v-tabs",
  computed: {
    ...mapGetters(["menuItems", "authData"]),
    hideListing: function() {
      return this.isInEditMode;
    },
    dragAreaHeightSize() {
      return this.dragAreaHeight + "px";
    }
  },
  components: {
    draggable
  },
  methods: {
    openCard(event, id) {
      this.$router.push("/boards/" + this.$route.params.id + "/cards/" + id);
    },
    editLink() {
      return "/board/" + this.$route.params.id;
    },
    addLink() {
       return "/boards/" + this.$route.params.id + "/cards/add";
    },
    goBackAction() {
      this.$router.push("/boards/" + this.$route.params.id);
    },
    load() {
      this.isLoadingData = true;
      this.boards = [];

      GenericRepository.getCollection("/api/boards/" + this.$route.params.id)
        .then(
          function(response) {
            if (response.data.status == "Success") {
              let items = HAL.getEmbededResources(response.data, "help:status");
              for (let i in items) {
                items[i].refName = "status_" + items[i].statusId;
                items[i].cardLink = HAL.getLink(items[i], "help:board-card");
                items[i].cards = [];
                this.boards.push(items[i]);
              }

              if (items.length > 0) this.isLoadingData = false;
            }
          }.bind(this)
        )
        .finally(
          function() {
            for (let i in this.boards) {
              if (this.boards[i].cardLink && this.boards[i].cardLink.href) {
                GenericRepository.getCollection(
                  this.boards[i].cardLink.href
                ).then(
                  function(response) {
                    if (response.data.status == "Success") {
                      let items = HAL.getEmbededResources(
                        response.data,
                        "help:card"
                      );
                      for (let i in items) {
                        items[i].refName = "card_" + items[i].cardId;
                        let updateStatusLink = HAL.getLink(
                          items[i],
                          "help:card-status-update"
                        );
                        items[i].updateStatusHref = updateStatusLink
                          ? updateStatusLink.href
                          : null;

                        this.cards.push(items[i]);
                      }

                      if (items.length > 0) this.isLoadingData = false;
                    }
                  }.bind(this.boards[i])
                );
              }
            }
          }.bind(this)
        );
    },
    handleResizeWindow() {
      if (this.isResizing) return;

      this.isResizing = true;
      setTimeout(
        function() {
          this.dragAreaHeight = window.innerHeight - 85 - 80;
          this.isResizing = false;
        }.bind(this),
        100
      );
    },
    itemMovedHandler(event) {
      if (event.added) {
        var cardId = event.added.element.cardId;
        var newStatusId = null;
        var oldStatusId = null;
        var updateLink = null;
        var card = null;
        for (var i in this.boards) {
          var found = false;
          for (var k in this.boards[i].cards) {
            if (this.boards[i].cards[k].cardId == cardId) {
              newStatusId = this.boards[i].statusId;
              oldStatusId = this.boards[i].cards[k].statusId;
              updateLink = this.boards[i].cards[k].updateStatusHref;
              card = this.boards[i].cards[k];
              found = true;
              break;
            }
          }

          if (found) break;
        }

        if (updateLink && newStatusId) {
          this.changeStatus(updateLink, newStatusId, oldStatusId, card);
        }
      }
    },

    changeStatus(updateLink, newStatusId, oldStatusId, card) {
      GenericRepository.update(updateLink, { statusId: newStatusId }).then(
        function(response) {
          if (response.data && response.data.status == "Success") {
            card.statusId = newStatusId;
          } else {
            for (let i in this.boards) {
              if (this.boards[i].statusId == newStatusId) {
                var ix = this.boards[i].cards.indexOf(card);
                if (ix != -1) {
                  this.boards[i].cards.splice(ix, 1);
                }
                break;
              }
            }
            for (let i in this.boards) {
              if (this.boards[i].statusId == oldStatusId) {
                this.boards[i].cards.push(card);
                break;
              }
            }
          }
        }.bind(this)
      );
    }
  },
  data() {
    return {
      isResizing: false,
      dragAreaHeight: 200,
      fab: false,
      active: 0,
      drag: false,
      isInEditMode: false,
      isLoadingData: false,
      href: "",
      cardHref: "",
      boards: [],
      options: {
        dropzoneSelector: ".drag-inner-list",
        draggableSelector: ".drag-item"
      }
    };
  },
  created() {
    window.addEventListener("resize", this.handleResizeWindow);
    this.load();
    this.dragAreaHeight = window.innerHeight - 85 - 80;
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResizeWindow);
  },
  watch: {
    "$route.params.id": function() {
      this.load();
    },
    "$route.params.cid": function(id) {
      if (id) this.isInEditMode = true;
      else this.isInEditMode = false;
    }
  }
};
</script>
<style lang="stylus">
@import '../../stylus/main.styl';
@import '../../assets/css/listing.css';
@import '../../assets/css/board.css';
</style>